import { AnalyticsEvent } from '../models';

export class GuacModeLinkClickEvent implements AnalyticsEvent {
    guacModeLinkClickEventType: string;
    guacModeClickType: string;
    guacModeIsEnrolledInLoyalty: boolean;
    name = 'GuacModeLinkClickEvent';

  constructor(public readonly event: string, public readonly clickType: string, public readonly isEnrolledInLoyalty: boolean = false) {
    this.guacModeLinkClickEventType = event;
    this.guacModeClickType = clickType;
    this.guacModeIsEnrolledInLoyalty = isEnrolledInLoyalty;
  }
}